export enum FEATURE_FLAG {
  voucherActivation = "voucherActivation",
}

export interface IFeatureConfigResponse {
  featureFlags: {
    featureFlagType: FEATURE_FLAG;
    value: boolean;
  }[];
}

export type TFeatureConfigEntry = Record<FEATURE_FLAG, boolean>;
